/* ==========================================================================
   PC Calculator Index
   Self-contained. Loaded only on the calculator index page.
   Filters the list as you type. Every card is a plain link, so the page is
   fully usable with JavaScript disabled.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-ci]');
  if (!root) return;

  var input  = root.querySelector('[data-ci-filter]');
  var count  = root.querySelector('[data-ci-count]');
  var empty  = root.querySelector('[data-ci-empty]');
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-group]'));
  if (!input) return;

  var cards = [];
  groups.forEach(function (g) {
    /* Include the group heading in the searchable text so a category word
       like "brake" finds every brake tool, not only the ones with the word
       in their own name. */
    var heading = g.querySelector('.pc-ci__group-title');
    var groupText = heading ? ' ' + heading.textContent : '';
    Array.prototype.slice.call(g.querySelectorAll('.pc-ci__card')).forEach(function (c) {
      cards.push({ el: c, group: g, text: (c.textContent + groupText).toLowerCase() });
    });
  });
  var TOTAL = cards.length;

  function apply() {
    var q = input.value.trim().toLowerCase();

    if (!q) {
      cards.forEach(function (c) { c.el.hidden = false; });
      groups.forEach(function (g) { g.hidden = false; });
      empty.hidden = true;
      count.textContent = '';
      return;
    }

    /* Every word has to appear somewhere in the card, so "brake fluid"
       narrows rather than widening. */
    var words = q.split(/\s+/);
    var shown = 0;

    cards.forEach(function (c) {
      var hit = words.every(function (w) { return c.text.indexOf(w) > -1; });
      c.el.hidden = !hit;
      if (hit) shown++;
    });

    groups.forEach(function (g) {
      var any = Array.prototype.slice.call(g.querySelectorAll('.pc-ci__card'))
        .some(function (c) { return !c.hidden; });
      g.hidden = !any;
    });

    empty.hidden = shown > 0;
    count.textContent = shown === TOTAL
      ? ''
      : shown + ' of ' + TOTAL + ' calculator' + (TOTAL === 1 ? '' : 's');
  }

  input.addEventListener('input', apply);
  input.addEventListener('search', apply);
  apply();
})();
